<template>
    <b-card v-bind:class="{active: active, 'flash': invalid}" class="prompt-message">
        <div class="prompt-message-header" slot="header">
            <table class="table">
                <tbody>
                    <tr>
                        <td width="40" v-bind:class="{active: active}" class="toggle-open text-center" @click="togglePrompt">
                            <font-awesome-icon icon="caret-right" :rotation="(active) ? 90 : null"></font-awesome-icon>
                        </td>
                        <td>
                            <b-input ref="prompt_filename" type="text" v-model="name" placeholder="Filename" @focus="active = true" :disabled="review" />
                        </td>
                        <td width="170" class="text-right">
                            <font-awesome-icon v-if="$store.state.calculating" icon="spinner" pulse />
                            {{ countWords() }} <strong>Words</strong> <span v-if="pricing.type == 'prompt'">/
                            {{line_amount}}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <slide-up-down :active="active" :duration="300" @open-end="resizeTextarea">  
            <div v-if="active" class="prompt-message-body">
                <b-row>
                    <b-col sm="12">
                        <b-form-group label="Message">
                            <b-textarea  ref="prompt_text" v-model="text" placeholder="Enter your message"  @blur.native="savePrompt(cut)" :disabled="review"></b-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="6">
                        <b-form-group label="Context">
                            <b-input type="text" v-model="context" placeholder="Enter the context" @blur.native="savePrompt(cut)" aria-describedby="context-help" :disabled="review" />
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Notes">
                            <b-input type="text" v-model="notes" placeholder="Enter any notes" @blur.native="savePrompt(cut)" aria-describedby="notes-help" :disabled="review" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="text-right">
                        <b-button variant="danger" class="delete-button danger float-right" @click="remove()" v-if="!review"><font-awesome-icon icon="trash" /> Delete</b-button>
                    </b-col>
                </b-row>
            </div>
        </slide-up-down>
    </b-card>
</template>

<script>
    export default {
        props: ['cut', 'project_id', 'prompt', 'price_per_prompt', 'extra_words_price', 'pricing', 'open', 'review', 'submitting'],
        data() {
            return {
                id: null,
                active: false,
                name: '',
                text: this.prompt.text,
                context: this.context,
                word_count: this.prompt.word_count,
                extra_words_count: this.extra_words_count,
                extra_words_fee: 0,
                amount: 0,
                notes: '',
                saved: false,
                scrollHeight: 0
            };
        },
        methods: {
            togglePrompt () {
                this.active = !this.active
            },
            remove: function() {
                this.$store.dispatch('prompt/delete', {id: this.id, index: this.cut})
            },
             //Get the word count from the prompt text
            countWords: function() {
                var words = this.text.replace(/(^\s*)|(\s*$)/gi,"");
	            words = words.replace(/[ ]{2,}/gi," ");
	            words = words.replace(/\n/g," ");
                words = words.replace(/\s\s+/g, ' ');
                var word_count = (words == "") ? 0 : words.split(' ').length;

                

                if( word_count > 25 ) {
                    this.extra_words_count = word_count - 25;
                    this.extra_words_fee  = ( this.extra_words_count * parseFloat(this.extra_words_price) );
                    this.amount = this.extra_words_fee + 10;
                } else {
                    this.extra_words_count = 0;
                    this.amount = this.price_per_prompt;
                }

                return this.word_count = word_count;
            },
            savePrompt: function(index, prompt) {
                if (this.text === '') {
                    return
                }

                let data = {
                    text: this.text,
                    name: ( this.name === '' ) ? 'Prompt_' + (this.cut + 1) : this.name,
                    context: this.context,
                    notes: this.notes
                }

                if (!this.id) {
                    data.project_id = this.project_id

                    this.$store.dispatch('prompt/create', {data: data, index: index})
                        .then(prompt => {
                            this.id = prompt.uuid;
                            this.saved = true
                            this.amount = prompt.amount;
                        })
                } else {
                    data.id = this.id
                    this.$store.dispatch('prompt/update', {data: data, index: index})
                        .then(prompt => {
                            this.saved = true
                            this.amount = prompt.amount
                        })
                }
            },
            resizeTextarea: function() {
                if( typeof(this.$refs.prompt_text) === 'undefined' ) {
                    return;
                }
                this.$refs.prompt_text.$el.style.height = '50px';
                this.$refs.prompt_text.$el.style.height = (parseFloat(this.$refs.prompt_text.$el.scrollHeight) + 10) + 'px';
            }
        },
        computed: {
            line_amount: function() {
                return '$' + parseFloat(this.prompt.amount).toFixed(2);
            },
            extra_words_fee_format: function() {
                return '$' + this.extra_words_fee.toFixed(2);
            },
            isActive: function() {
                if(this.open || this.active) {
                    return true;
                }

                return false;
            },
            rotate () {
                return (this.active) ? 90 : 0;
            },
            invalid () {
                return (this.text === '' && this.submitting)
            }
        },
        updated: function(){
            this.resizeTextarea();
        },
        watch: {
            'prompt': {
                handler: function(oldVal, newVal) {
                    this.id = this.prompt.uuid;
                    this.name = this.prompt.name;
                    this.amount = parseFloat(this.prompt.amount);
                    this.text = this.prompt.text;
                    this.word_count = this.prompt.word_count;
                    this.extra_words_count = this.prompt.extra_words_count;
                    this.context = this.prompt.context;
                    this.notes = this.prompt.notes;
                    this.resizeTextarea();
                }
            },
            'text': {
                handler: function(old, newVal) {
                    this.resizeTextarea();
                }
            },
            'open': {
                handler: function(newVal, oldVal) {
                    this.active = newVal;
                }
            }
        },
        created() {
            if (this.prompt.uuid) {
                this.id = this.prompt.uuid
            }
            
            this.name = this.prompt.name
            this.text = this.prompt.text
            this.amount = parseFloat(this.prompt.amount)
            this.word_count = this.prompt.word_count
            this.extra_words_count = this.prompt.extra_words_count
            this.context = this.prompt.context
            this.notes = this.prompt.notes
        },
        mounted() {
            // this.resizeTextarea();

            if (this.cut == 0 && !this.review) {
                this.active = true
            }
        }
    }


</script>


// WEBPACK FOOTER //
// prompts/components/project/Prompt.vue